import React, { FC } from "react";

import { useIntl } from "react-intl";

import { GuideUserStatus } from "@mapmycustomers/shared/types/entity";

import Table from "@app/component/Table";

import useColumns from "./useColumns";

export interface UserTableProps {
  className?: string;
  guideStatus?: GuideUserStatus[];
}

const UsersTable: FC<UserTableProps> = ({ className, guideStatus }) => {
  const intl = useIntl();
  const columns = useColumns(intl);

  return (
    <Table<GuideUserStatus>
      className={className}
      columns={columns}
      dataSource={guideStatus}
      rowKey="id"
      scrollable
      showBorder
    />
  );
};

export default UsersTable;
